import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Hotel = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("circle", { cx: 7, cy: 11, r: 2, key: "k0" }),
        React.createElement("path", { d: "M20 15H4V6H2v14h2v-3h16v3h2v-4c0-.009-.005-.016-.005-.024H22V15h-2z", key: "k1" }),
        React.createElement("path", { d: "M18.205 7H10v7.061h12V11c0-2.096-1.698-4-3.795-4z", key: "k2" })));
});
Hotel.displayName = 'Hotel';
export var HotelDimensions = { height: 24, width: 24 };
